import { Injectable, Component, ViewContainerRef, NgModule, ChangeDetectionStrategy, Input, EventEmitter, Output } from '@angular/core';
import { RestService, FileService, SessionManagerService, AuthenticateService, CommonUtilsService, UiCoreModule, coerceResponseErrors } from '@pubmatic/ui-core';
import { Subscription } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { months, DialogService, DialogModule, PanelModule, DropdownModule, SpinnerModule, ScrollableTableModule, NotifiersModule, ButtonModule, GlobalHeaderModule, IconModule, FileModule } from '@pubmatic/pmcc';
import { map, finalize, catchError } from 'rxjs/operators';
import { HttpHeaders } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@pubmatic/ui-core';
import * as ɵngcc2 from '@pubmatic/pmcc';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@angular/router';
import * as ɵngcc5 from '@angular/forms';

function BillingStatementComponent_pmcc_spinner_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "pmcc-spinner", 13);
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("size", 4);
} }
function BillingStatementComponent_pmcc_message_box_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "pmcc-message-box", 14);
    ɵngcc0.ɵɵi18n(1, 15);
    ɵngcc0.ɵɵelementEnd();
} }
function BillingStatementComponent_table_10_ng_container_2_tr_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵelementStart(1, "td");
    ɵngcc0.ɵɵelementStart(2, "a", 19);
    ɵngcc0.ɵɵlistener("click", function BillingStatementComponent_table_10_ng_container_2_tr_1_Template_a_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r8); const statement_r4 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.downloadBillingStatement(statement_r4.name); });
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "date");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "td");
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "date");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(8, "td");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const statement_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("data-pm-id", "billing-statement-" + statement_r4.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(4, 3, statement_r4.time, "MMMM"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(7, 6, statement_r4.time, "y"));
} }
function BillingStatementComponent_table_10_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, BillingStatementComponent_table_10_ng_container_2_tr_1_Template, 9, 9, "tr", 18);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const statement_r4 = ctx.$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.isStatementVisible(statement_r4));
} }
function BillingStatementComponent_table_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "table", 16);
    ɵngcc0.ɵɵelementStart(1, "tbody");
    ɵngcc0.ɵɵtemplate(2, BillingStatementComponent_table_10_ng_container_2_Template, 2, 1, "ng-container", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.billingStatementList);
} }
function FooterComponent_li_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "a", 7);
    ɵngcc0.ɵɵi18n(2, 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("href", ctx_r0.tos[ctx_r0.type], ɵngcc0.ɵɵsanitizeUrl);
} }
function FooterComponent_a_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 12);
    ɵngcc0.ɵɵelement(1, "pmcc-icon", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const link_r2 = ctx.$implicit;
    ɵngcc0.ɵɵpropertyInterpolate("href", link_r2.url, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("name", link_r2.icon);
} }
function SystemNotificationComponent_ul_0_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "pmcc-message-box", 3);
    ɵngcc0.ɵɵlistener("closed", function SystemNotificationComponent_ul_0_li_1_Template_pmcc_message_box_closed_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(2); return ctx_r3.onClose($event); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const n_r2 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", n_r2.text, " ");
} }
function SystemNotificationComponent_ul_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 1);
    ɵngcc0.ɵɵtemplate(1, SystemNotificationComponent_ul_0_li_1_Template, 3, 1, "li", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.tagNotifications);
} }
class AnalyticsService {
    constructor(rest, fileService, sm) {
        this.rest = rest;
        this.fileService = fileService;
        this.publisherId = sm.getAccountId();
        this.token = sm.getApiToken();
    }
    parseBillingStatement(name) {
        const [prefix, date, suffix] = name.split('_');
        const [monthName, last2DigitsOfYear] = date.split(`'`);
        const year = 2000 + +last2DigitsOfYear; // tslint:disable-line
        const month = months.find(m => m.label.startsWith(monthName));
        return {
            name,
            time: new Date(year, month.value),
        };
    }
    getBilling() {
        return this.rest.get(`/api/analytics/billing/statements/${this.publisherId}`).pipe(map(names => names.map(n => this.parseBillingStatement(n))), map(names => names.sort((a, b) => +b.time - +a.time)));
    }
    downloadBilling(name) {
        return this.fileService.download(`/api/analytics/billing/statements/download/${this.publisherId}/${name}`, {
            params: {
                [this.token.key]: this.token.value,
            },
        });
    }
    getAlertCount() {
        return this.rest.get('/api/analytics/alert/msgs/count');
    }
    getAlertList(size) {
        return this.rest.get('/api/analytics/alert/msgs?pageSize=' + size, {
            headers: new HttpHeaders({
                resourceType: 'publisher',
                resourceId: this.publisherId
            })
        });
    }
}
AnalyticsService.ɵfac = function AnalyticsService_Factory(t) { return new (t || AnalyticsService)(ɵngcc0.ɵɵinject(ɵngcc1.RestService), ɵngcc0.ɵɵinject(ɵngcc1.FileService), ɵngcc0.ɵɵinject(ɵngcc1.SessionManagerService)); };
AnalyticsService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AnalyticsService, factory: AnalyticsService.ɵfac });
AnalyticsService.ctorParameters = () => [
    { type: RestService },
    { type: FileService },
    { type: SessionManagerService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AnalyticsService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.RestService }, { type: ɵngcc1.FileService }, { type: ɵngcc1.SessionManagerService }]; }, null); })();

class BillingStatementComponent {
    constructor(analyticsService) {
        this.analyticsService = analyticsService;
        this.viewOptions = [
            {
                label: 'Publisher Billing',
                value: "publisherBilling" /* PublisherBilling */,
            }
        ];
        this.yearOptions = [
            {
                label: 'All',
                value: "all" /* All */,
            },
        ];
        this.view = this.viewOptions[0];
        this.year = this.yearOptions[0];
        this.billingStatementList = [];
        this.loading = false;
    }
    ngOnInit() {
        this.loading = true;
        this.analyticsService.getBilling()
            .pipe(finalize(() => this.loading = false))
            .subscribe(statements => {
            this.billingStatementList = statements;
            this.setYearOptions();
        });
    }
    isStatementVisible(statement) {
        return this.year.value === "all" /* All */
            || statement.time.getFullYear().toString() === this.year.value.toString();
    }
    downloadBillingStatement(name) {
        // triggers browser's file download
        this.analyticsService.downloadBilling(encodeURIComponent(name)).subscribe();
    }
    setYearOptions() {
        this.billingStatementList
            .map(statement => statement.time.getFullYear())
            // to get unique year
            .filter((year, i, arr) => arr.indexOf(year) === i)
            .forEach((year) => this.yearOptions.push({ label: year.toString(), value: year.toString() }));
    }
}
BillingStatementComponent.ɵfac = function BillingStatementComponent_Factory(t) { return new (t || BillingStatementComponent)(ɵngcc0.ɵɵdirectiveInject(AnalyticsService)); };
BillingStatementComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BillingStatementComponent, selectors: [["pmac-billing-statement"]], decls: 14, vars: 6, consts: function () { let i18n_0; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_billingStatementsYear$$FESM2015_PUBMATIC_PMAC_JS_1 = goog.getMsg(" Year: ");
        i18n_0 = MSG_EXTERNAL_billingStatementsYear$$FESM2015_PUBMATIC_PMAC_JS_1;
    }
    else {
        i18n_0 = $localize `:@@billingStatementsYear␟4fe36d3fb5ae057cc94d7f5724752a5b26ebafaa␟4149566337567678636: Year: `;
    } let i18n_2; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_billingStatementsClose$$FESM2015_PUBMATIC_PMAC_JS_3 = goog.getMsg(" Close ");
        i18n_2 = MSG_EXTERNAL_billingStatementsClose$$FESM2015_PUBMATIC_PMAC_JS_3;
    }
    else {
        i18n_2 = $localize `:@@billingStatementsClose␟5d49ee389add9351d1a4e56d4c8200eff140b932␟3912307190518681177: Close `;
    } let i18n_4; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_noBillingStatements$$FESM2015_PUBMATIC_PMAC_JS__5 = goog.getMsg("You have no billing statements.");
        i18n_4 = MSG_EXTERNAL_noBillingStatements$$FESM2015_PUBMATIC_PMAC_JS__5;
    }
    else {
        i18n_4 = $localize `:@@noBillingStatements␟32a2e7b6a160b1e79a67be85129e38c2bef5cb78␟1918072976161877255:You have no billing statements.`;
    } return [["type", "non-modal", "size", "large", "title", "Billing Statement", 3, "showDialog"], [1, "pmcc-dialog-content", "pmcc-no-pad"], [1, "pmcc-toolbar"], ["data-pm-id", "billing-statements-year", 1, "pmcc-label"], i18n_0, [3, "options", "model", "modelChange"], [1, "container"], [3, "size", 4, "ngIf"], ["data-pm-id", "no-billing-statements", "type", "inform", 4, "ngIf"], ["class", "pmcc-table-light", 4, "ngIf"], [1, "pmcc-dialog-footer", "pmcc-justify-content-end"], ["pmccButton", "", "pmccVariant", "primary", "pmccSize", "md", "pmccDialogClose", "", "data-pm-id", "billing-statement-close", 1, "pmcc-right"], i18n_2, [3, "size"], ["data-pm-id", "no-billing-statements", "type", "inform"], i18n_4, [1, "pmcc-table-light"], [4, "ngFor", "ngForOf"], [4, "ngIf"], [1, "month", 3, "click"]]; }, template: function BillingStatementComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "pmcc-dialog", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "pmcc-panel");
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵi18n(5, 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "pmcc-dropdown", 5);
        ɵngcc0.ɵɵlistener("modelChange", function BillingStatementComponent_Template_pmcc_dropdown_modelChange_6_listener($event) { return ctx.year = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 6);
        ɵngcc0.ɵɵtemplate(8, BillingStatementComponent_pmcc_spinner_8_Template, 1, 1, "pmcc-spinner", 7);
        ɵngcc0.ɵɵtemplate(9, BillingStatementComponent_pmcc_message_box_9_Template, 2, 0, "pmcc-message-box", 8);
        ɵngcc0.ɵɵtemplate(10, BillingStatementComponent_table_10_Template, 3, 1, "table", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 10);
        ɵngcc0.ɵɵelementStart(12, "button", 11);
        ɵngcc0.ɵɵi18n(13, 12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("showDialog", true);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("options", ctx.yearOptions)("model", ctx.year);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.loading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.billingStatementList.length && !ctx.loading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.billingStatementList.length);
    } }, directives: [ɵngcc2.DialogComponent, ɵngcc2.PanelComponent, ɵngcc2.DropdownComponent, ɵngcc3.NgIf, ɵngcc2.ButtonDirective, ɵngcc2.DialogCloseDirective, ɵngcc2.SpinnerComponent, ɵngcc2.MessageBoxComponent, ɵngcc3.NgForOf], pipes: [ɵngcc3.DatePipe], styles: ["pmcc-panel[_ngcontent-%COMP%]   .pmcc-toolbar[_ngcontent-%COMP%]{border-radius:0;box-shadow:none;display:flex;align-items:center}pmcc-panel[_ngcontent-%COMP%]   .pmcc-toolbar[_ngcontent-%COMP%]   .pmcc-label[_ngcontent-%COMP%]{margin-right:5px}pmcc-panel[_ngcontent-%COMP%]   .pmcc-toolbar[_ngcontent-%COMP%]   pmcc-dropdown[_ngcontent-%COMP%]{margin-right:10px}tbody[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{width:25%}tbody[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:last-child{width:100%}.month[_ngcontent-%COMP%]{font-weight:700;cursor:pointer;padding-left:5px}.container[_ngcontent-%COMP%]{position:relative;background:#fff;min-height:300px;height:300px;overflow:auto}"] });
BillingStatementComponent.ctorParameters = () => [
    { type: AnalyticsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BillingStatementComponent, [{
        type: Component,
        args: [{
                selector: 'pmac-billing-statement',
                template: "<pmcc-dialog\n  [showDialog]=\"true\"\n  type=\"non-modal\"\n  size=\"large\"\n  title=\"Billing Statement\"\n>\n  <div class=\"pmcc-dialog-content pmcc-no-pad\">\n    <pmcc-panel>\n      <div class=\"pmcc-toolbar\">\n        <div\n          class=\"pmcc-label\"\n          i18n=\"@@billingStatementsYear\"\n          data-pm-id=\"billing-statements-year\"\n        >\n          Year:\n        </div>\n        <pmcc-dropdown\n          [options]=\"yearOptions\"\n          [(model)]=\"year\"\n        ></pmcc-dropdown>\n      </div>\n    </pmcc-panel>\n\n    <div class=\"container\">\n      <pmcc-spinner *ngIf=\"loading\" [size]=\"4\"></pmcc-spinner>\n      <pmcc-message-box\n        *ngIf=\"!billingStatementList.length && !loading\"\n        data-pm-id=\"no-billing-statements\"\n        type=\"inform\"\n        i18n=\"@@noBillingStatements\">You have no billing statements.</pmcc-message-box>\n      <table class=\"pmcc-table-light\" *ngIf=\"billingStatementList.length\">\n        <tbody>\n          <ng-container *ngFor=\"let statement of billingStatementList\">\n            <tr *ngIf=\"isStatementVisible(statement)\">\n              <td>\n                <a\n                  class=\"month\"\n                  (click)=\"downloadBillingStatement(statement.name)\"\n                  [attr.data-pm-id]=\"'billing-statement-' + statement.name\"\n                >\n                  {{ statement.time | date: 'MMMM' }}\n                </a>\n              </td>\n              <td>{{ statement.time | date: 'y' }}</td>\n              <td></td>\n            </tr>\n          </ng-container>\n        </tbody>\n      </table>\n    </div>\n  </div>\n\n  <div class=\"pmcc-dialog-footer pmcc-justify-content-end\">\n    <button\n      class=\"pmcc-right\"\n      pmccButton\n      pmccVariant=\"primary\"\n      pmccSize=\"md\"\n      pmccDialogClose\n      i18n=\"@@billingStatementsClose\"\n      data-pm-id=\"billing-statement-close\"\n    >\n      Close\n    </button>\n  </div>\n</pmcc-dialog>\n",
                styles: ["pmcc-panel .pmcc-toolbar{border-radius:0;box-shadow:none;display:flex;align-items:center}pmcc-panel .pmcc-toolbar .pmcc-label{margin-right:5px}pmcc-panel .pmcc-toolbar pmcc-dropdown{margin-right:10px}tbody td{width:25%}tbody td:last-child{width:100%}.month{font-weight:700;cursor:pointer;padding-left:5px}.container{position:relative;background:#fff;min-height:300px;height:300px;overflow:auto}"]
            }]
    }], function () { return [{ type: AnalyticsService }]; }, null); })();

/**
 * Demo example
 * <example-url>/demo/#/pmac/header</example-url>
 */
class HeaderComponent {
    constructor(viewContainerRef, service, sm, authenticate, router, commonUtils, dialogService) {
        this.viewContainerRef = viewContainerRef;
        this.service = service;
        this.sm = sm;
        this.authenticate = authenticate;
        this.router = router;
        this.commonUtils = commonUtils;
        this.dialogService = dialogService;
        this.menus = [];
        this.homeUrl = 'https://www.pubmatic.com';
        this.activeMenu = '';
        this.logoutHidden = false;
        this._routerSub = Subscription.EMPTY;
    }
    ngOnInit() {
        if (!this.sm.isInitialized()) {
            console.error('Session not available');
            return;
        }
        const struct = this.sm.get('headerStructure');
        if (struct) {
            this.logoutHidden = struct.logoutHidden;
            this.homeUrl = struct.homeUrl;
            this.help = struct.help;
            this.menus = struct.menus;
            this.userInfo = struct.userInfo;
            this.userInfoMenu = struct.userInfoMenu;
            this.alertsUrl = {
                list: struct.alertsUrl,
                create: struct.createAlertUrl
            };
            this.setActiveParentNavMenu();
            this.locationChangeHandler();
            if (this.sm.getAppName() === "PUBLISHER" /* PUBLISHER */) {
                if (!this.sm.getAccess(234 /* ANALYTICS_DEMO_USER */)) {
                    this.addBillingStatements();
                }
                this.fetchAlerts();
            }
        }
        else {
            console.error('Structure is not available');
        }
    }
    ngOnDestroy() {
        this._routerSub.unsubscribe();
    }
    locationChangeHandler() {
        this._routerSub = this.router.events
            .subscribe(val => {
            if (val instanceof NavigationEnd) {
                this.setActiveParentNavMenu();
            }
        });
    }
    addBillingStatements() {
        this.userInfoMenu = [
            ...this.userInfoMenu,
            {
                id: 'billing-statements',
                items: [{
                        label: 'Billing Statements',
                        click: (event) => {
                            // preventDefault is used to prevent link from activating if
                            // click is specified in a header menu item
                            event.preventDefault();
                            this.dialogService.open(BillingStatementComponent, {
                                viewContainerRef: this.viewContainerRef,
                            });
                        },
                    }],
            }
        ];
    }
    isUrlMatching(url) {
        const currentPageUrl = this.commonUtils.getWindowLocation();
        return currentPageUrl.match(this.commonUtils.qualifyURL(url));
    }
    searchPages(pages) {
        return pages.find(page => this.isUrlMatching(typeof page === 'string' ? page : page.url));
    }
    searchChildren(menu) {
        return menu.find(
        // todo: fix coverage
        /* istanbul ignore next */
        (child) => this.searchPages(child.items || []));
    }
    setActiveParentNavMenu() {
        const activeParentTab = this.menus.find(item => (this.searchPages(item.otherPages || []) ||
            this.searchChildren(item.groups || [])));
        if (activeParentTab) {
            this.activeMenu = activeParentTab.id;
        }
    }
    fetchAlerts() {
        const MAX_ALERTS = 5;
        this.service.getAlertCount().subscribe(count => {
            this.service.getAlertList(MAX_ALERTS).subscribe(response => this.setAlerts(count.unreadCount, response), err => this.setAlerts(0, []));
        }, err => this.setAlerts(0, []));
    }
    setAlerts(count, list) {
        this.alertsModel = {
            alertsCount: count,
            alerts: list.map(v => ({
                label: v.title,
                url: v.url
            })),
            viewAllUrl: this.alertsUrl.list,
            createUrl: this.alertsUrl.create
        };
    }
    onLogout(eventArgs) {
        this.authenticate.logout();
    }
}
HeaderComponent.ɵfac = function HeaderComponent_Factory(t) { return new (t || HeaderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(AnalyticsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.SessionManagerService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.AuthenticateService), ɵngcc0.ɵɵdirectiveInject(ɵngcc4.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.CommonUtilsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.DialogService)); };
HeaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HeaderComponent, selectors: [["pmac-header"]], decls: 2, vars: 8, consts: [[1, "pmac-global-header-element", 3, "menus", "activeMenu", "alerts", "help", "homeUrl", "userInfo", "userInfoMenu", "logoutHidden", "logoutCallback"]], template: function HeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "header");
        ɵngcc0.ɵɵelementStart(1, "pmcc-global-header", 0);
        ɵngcc0.ɵɵlistener("logoutCallback", function HeaderComponent_Template_pmcc_global_header_logoutCallback_1_listener($event) { return ctx.onLogout($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("menus", ctx.menus)("activeMenu", ctx.activeMenu)("alerts", ctx.alertsModel)("help", ctx.help)("homeUrl", ctx.homeUrl)("userInfo", ctx.userInfo)("userInfoMenu", ctx.userInfoMenu)("logoutHidden", ctx.logoutHidden);
    } }, directives: [ɵngcc2.GlobalHeaderComponent], styles: [""] });
HeaderComponent.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: AnalyticsService },
    { type: SessionManagerService },
    { type: AuthenticateService },
    { type: Router },
    { type: CommonUtilsService },
    { type: DialogService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HeaderComponent, [{
        type: Component,
        args: [{
                selector: 'pmac-header',
                template: "<header>\n  <pmcc-global-header\n    class=\"pmac-global-header-element\"\n    [menus]=\"menus\"\n    [activeMenu]=\"activeMenu\"\n    [alerts]=\"alertsModel\"\n    [help]=\"help\"\n    [homeUrl]=\"homeUrl\"\n    [userInfo]=\"userInfo\"\n    [userInfoMenu]=\"userInfoMenu\"\n    [logoutHidden]=\"logoutHidden\"\n    (logoutCallback)=\"onLogout($event)\"\n  ></pmcc-global-header>\n</header>\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: AnalyticsService }, { type: ɵngcc1.SessionManagerService }, { type: ɵngcc1.AuthenticateService }, { type: ɵngcc4.Router }, { type: ɵngcc1.CommonUtilsService }, { type: ɵngcc2.DialogService }]; }, null); })();

class SharedModule {
}
SharedModule.ɵfac = function SharedModule_Factory(t) { return new (t || SharedModule)(); };
SharedModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SharedModule });
SharedModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        AnalyticsService,
    ], imports: [[
            CommonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SharedModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [
                    CommonModule
                ],
                providers: [
                    AnalyticsService,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SharedModule, { imports: function () { return [CommonModule]; } }); })();

class BillingStatementModule {
}
BillingStatementModule.ɵfac = function BillingStatementModule_Factory(t) { return new (t || BillingStatementModule)(); };
BillingStatementModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: BillingStatementModule });
BillingStatementModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            SharedModule,
            DialogModule,
            PanelModule,
            DropdownModule,
            SpinnerModule,
            ScrollableTableModule,
            NotifiersModule,
            ButtonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BillingStatementModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    BillingStatementComponent,
                ],
                imports: [
                    CommonModule,
                    SharedModule,
                    DialogModule,
                    PanelModule,
                    DropdownModule,
                    SpinnerModule,
                    ScrollableTableModule,
                    NotifiersModule,
                    ButtonModule
                ],
                exports: [
                    BillingStatementComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BillingStatementModule, { declarations: function () { return [BillingStatementComponent]; }, imports: function () { return [CommonModule, SharedModule, DialogModule,
        PanelModule,
        DropdownModule,
        SpinnerModule,
        ScrollableTableModule,
        NotifiersModule,
        ButtonModule]; }, exports: function () { return [BillingStatementComponent]; } }); })();

class HeaderModule {
}
HeaderModule.ɵfac = function HeaderModule_Factory(t) { return new (t || HeaderModule)(); };
HeaderModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HeaderModule });
HeaderModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            SharedModule,
            GlobalHeaderModule,
            UiCoreModule,
            BillingStatementModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HeaderModule, [{
        type: NgModule,
        args: [{
                declarations: [HeaderComponent],
                imports: [
                    CommonModule,
                    SharedModule,
                    GlobalHeaderModule,
                    UiCoreModule,
                    BillingStatementModule
                ],
                exports: [HeaderComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HeaderModule, { declarations: function () { return [HeaderComponent]; }, imports: function () { return [CommonModule, SharedModule, GlobalHeaderModule,
        UiCoreModule, BillingStatementModule]; }, exports: function () { return [HeaderComponent]; } }); })();

/**
 * Demo example
 * <example-url>/demo/#/pmac/footer</example-url>
 */
class FooterComponent {
    constructor() {
        this.copyrightYear = (new Date()).getFullYear();
        this.privacyPolicy = 'http://www.pubmatic.com/privacy-policy.php';
        this.tos = {
            'admin': '/AdGainMgmt/tos.jsp',
            'demand': '/mediaconsole/terms.html'
        };
        this.socialWidgets = [{
                'url': 'https://www.facebook.com/PubMatic',
                'icon': 'facebook-square'
            }, {
                'url': 'https://twitter.com/pubmatic',
                'icon': 'twitter-square'
            }, {
                'url': 'http://www.linkedin.com/company/pubmatic',
                'icon': 'linkedin-square'
            }];
    }
}
FooterComponent.ɵfac = function FooterComponent_Factory(t) { return new (t || FooterComponent)(); };
FooterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FooterComponent, selectors: [["pmac-footer"]], inputs: { type: "type" }, decls: 14, vars: 4, consts: function () { let i18n_6; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_8099334999944136987$$FESM2015_PUBMATIC_PMAC_JS_7 = goog.getMsg("{$interpolation} PubMatic, All Rights Reserved", { "interpolation": "\uFFFD0\uFFFD" });
        i18n_6 = MSG_EXTERNAL_8099334999944136987$$FESM2015_PUBMATIC_PMAC_JS_7;
    }
    else {
        i18n_6 = $localize `:␟1f14331a80424796c47e558075496992f20386ec␟8099334999944136987:${"\uFFFD0\uFFFD"}:INTERPOLATION: PubMatic, All Rights Reserved`;
    } let i18n_8; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_8439955599488894226$$FESM2015_PUBMATIC_PMAC_JS_9 = goog.getMsg("Privacy Policy");
        i18n_8 = MSG_EXTERNAL_8439955599488894226$$FESM2015_PUBMATIC_PMAC_JS_9;
    }
    else {
        i18n_8 = $localize `:␟b8d10cd55fae4e4ad4f87d28e18251694f159bf7␟8439955599488894226:Privacy Policy`;
    } let i18n_10; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_4242389206843989472$$FESM2015_PUBMATIC_PMAC_JS__11 = goog.getMsg("Terms of Use");
        i18n_10 = MSG_EXTERNAL_4242389206843989472$$FESM2015_PUBMATIC_PMAC_JS__11;
    }
    else {
        i18n_10 = $localize `:␟0dd8a3bafea23b5595cfcb897f16acd2cc60cf02␟4242389206843989472:Terms of Use`;
    } return [[1, "pmcc-footer", "pmcc-container-fluid"], [1, "pmcc-row", "footer-row"], [1, "pmcc-col-sm-6", "pmcc-align-self-center", "copyright"], i18n_6, [1, "pmcc-col-sm-6", "pmcc-align-self-center"], [1, "pmcc-text-right"], [4, "ngIf"], ["target", "_blank", 1, "pmcc-link", 3, "href"], i18n_8, [1, "social-widget"], ["rel", "noopener noreferrer", "target", "_blank", 3, "href", 4, "ngFor", "ngForOf"], i18n_10, ["rel", "noopener noreferrer", "target", "_blank", 3, "href"], ["color", "gray-lt", "size", "2x", 3, "name"]]; }, template: function FooterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "footer", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtext(3, " \u00A9 ");
        ɵngcc0.ɵɵelementStart(4, "label");
        ɵngcc0.ɵɵi18n(5, 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵelementStart(7, "ul", 5);
        ɵngcc0.ɵɵtemplate(8, FooterComponent_li_8_Template, 3, 1, "li", 6);
        ɵngcc0.ɵɵelementStart(9, "li");
        ɵngcc0.ɵɵelementStart(10, "a", 7);
        ɵngcc0.ɵɵi18n(11, 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "li", 9);
        ɵngcc0.ɵɵtemplate(13, FooterComponent_a_13_Template, 2, 2, "a", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵi18nExp(ctx.copyrightYear);
        ɵngcc0.ɵɵi18nApply(5);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.tos[ctx.type]);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("href", ctx.privacyPolicy, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.socialWidgets);
    } }, directives: [ɵngcc3.NgIf, ɵngcc3.NgForOf, ɵngcc2.IconComponent], styles: [".footer-row[_ngcontent-%COMP%]{height:100%}.social-widget[_ngcontent-%COMP%]{vertical-align:sub}.social-widget[_ngcontent-%COMP%]   a[_ngcontent-%COMP%] + a[_ngcontent-%COMP%]{padding-left:10px}"], changeDetection: 0 });
FooterComponent.ctorParameters = () => [];
FooterComponent.propDecorators = {
    type: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FooterComponent, [{
        type: Component,
        args: [{
                selector: 'pmac-footer',
                template: "<footer class=\"pmcc-footer pmcc-container-fluid\">\n  <div class=\"pmcc-row footer-row\">\n    <div class=\"pmcc-col-sm-6 pmcc-align-self-center copyright\">\n      &copy; <label i18n>{{copyrightYear}} PubMatic, All Rights Reserved</label>\n    </div>\n    <div class=\"pmcc-col-sm-6 pmcc-align-self-center\">\n      <ul class=\"pmcc-text-right\">\n        <li *ngIf=\"tos[type]\">\n          <a class=\"pmcc-link\" href=\"{{tos[type]}}\" i18n target=\"_blank\">Terms of Use</a>\n        </li>\n        <li>\n          <a class=\"pmcc-link\" href=\"{{privacyPolicy}}\" i18n target=\"_blank\">Privacy Policy</a>\n        </li>\n        <li class=\"social-widget\">\n          <a *ngFor=\"let link of socialWidgets\" href=\"{{link.url}}\" rel=\"noopener noreferrer\" target=\"_blank\">\n            <pmcc-icon [name]=\"link.icon\" color=\"gray-lt\" size=\"2x\"></pmcc-icon>\n          </a>\n        </li>\n      </ul>\n    </div>\n  </div>\n</footer>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".footer-row{height:100%}.social-widget{vertical-align:sub}.social-widget a+a{padding-left:10px}"]
            }]
    }], function () { return []; }, { type: [{
            type: Input
        }] }); })();

class FooterModule {
}
FooterModule.ɵfac = function FooterModule_Factory(t) { return new (t || FooterModule)(); };
FooterModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: FooterModule });
FooterModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            IconModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FooterModule, [{
        type: NgModule,
        args: [{
                declarations: [FooterComponent],
                imports: [
                    CommonModule,
                    IconModule
                ],
                exports: [FooterComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FooterModule, { declarations: function () { return [FooterComponent]; }, imports: function () { return [CommonModule,
        IconModule]; }, exports: function () { return [FooterComponent]; } }); })();

class SystemNotificationComponent {
    constructor(sm) {
        this.sm = sm;
        this.tagList = [];
        this.notifications = [];
        this.tagNotifications = []; // this is used by view to render notifications
        this.closedMessageCount = 0;
        this.displayNotification = false;
    }
    ngOnInit() {
        this.loadNotifications();
        this.showNotifications();
    }
    ngOnChanges() {
        this.showNotifications();
    }
    loadNotifications() {
        const notifications = this.sm.get('appNotifications') || [];
        this.notifications = notifications.map(n => ({
            id: n.notificationMessageId,
            text: n.message,
            tags: n.notificationTags.map((tag) => tag.toLowerCase())
        }));
    }
    showNotifications() {
        const tagsToDisplay = (this.tagList || []).map(tag => tag.toLowerCase());
        this.tagNotifications = this.notifications
            .filter(n => n.tags.some(t => tagsToDisplay.includes(t)))
            .sort(this.sortByLatest);
        this.displayNotification = this.tagNotifications && this.tagNotifications.length ? true : false;
    }
    sortByLatest(n1, n2) {
        return n1.id < n2.id ? 1 : -1;
    }
    onClose(params) {
        if (!params.value) {
            this.closedMessageCount++;
            if (this.closedMessageCount === this.tagNotifications.length) {
                this.displayNotification = false;
            }
        }
    }
}
SystemNotificationComponent.ɵfac = function SystemNotificationComponent_Factory(t) { return new (t || SystemNotificationComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.SessionManagerService)); };
SystemNotificationComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SystemNotificationComponent, selectors: [["pmac-system-notification"]], inputs: { tagList: "tagList" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "system-notification-container", 4, "ngIf"], [1, "system-notification-container"], [4, "ngFor", "ngForOf"], ["type", "inform", 3, "closed"]], template: function SystemNotificationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, SystemNotificationComponent_ul_0_Template, 2, 1, "ul", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.displayNotification);
    } }, directives: [ɵngcc3.NgIf, ɵngcc3.NgForOf, ɵngcc2.MessageBoxComponent], styles: [".system-notification-container[_ngcontent-%COMP%]{list-style-type:none;padding:0}"] });
SystemNotificationComponent.ctorParameters = () => [
    { type: SessionManagerService }
];
SystemNotificationComponent.propDecorators = {
    tagList: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SystemNotificationComponent, [{
        type: Component,
        args: [{
                selector: 'pmac-system-notification',
                template: "<ul class=\"system-notification-container\" *ngIf=\"displayNotification\">\n  <li *ngFor=\"let n of tagNotifications\">\n    <pmcc-message-box type=\"inform\" (closed)=\"onClose($event)\">\n      {{n.text}}\n    </pmcc-message-box>\n  </li>\n</ul>\n",
                styles: [".system-notification-container{list-style-type:none;padding:0}"]
            }]
    }], function () { return [{ type: ɵngcc1.SessionManagerService }]; }, { tagList: [{
            type: Input
        }] }); })();

class SystemNotificationModule {
}
SystemNotificationModule.ɵfac = function SystemNotificationModule_Factory(t) { return new (t || SystemNotificationModule)(); };
SystemNotificationModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SystemNotificationModule });
SystemNotificationModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, NotifiersModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SystemNotificationModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, NotifiersModule],
                declarations: [SystemNotificationComponent],
                exports: [SystemNotificationComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SystemNotificationModule, { declarations: function () { return [SystemNotificationComponent]; }, imports: function () { return [CommonModule, NotifiersModule]; }, exports: function () { return [SystemNotificationComponent]; } }); })();

class InfrastructureService {
    constructor(sm, fileService) {
        this.sm = sm;
        this.fileService = fileService;
        this.token = this.sm.getApiToken();
    }
    upload(url, file, resourceUrl, param) {
        const params = Object.assign({ [this.token.key]: this.token.value, resourceUrl: `${resourceUrl}`, mode: 'upload' }, param);
        return this.fileService.upload(url, file, { params })
            .pipe(catchError(err => {
            throw err;
        }));
    }
}
InfrastructureService.ɵfac = function InfrastructureService_Factory(t) { return new (t || InfrastructureService)(ɵngcc0.ɵɵinject(ɵngcc1.SessionManagerService), ɵngcc0.ɵɵinject(ɵngcc1.FileService)); };
InfrastructureService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: InfrastructureService, factory: InfrastructureService.ɵfac });
InfrastructureService.ctorParameters = () => [
    { type: SessionManagerService },
    { type: FileService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InfrastructureService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.SessionManagerService }, { type: ɵngcc1.FileService }]; }, null); })();

/**
 * Demo example
 * <example-url>/demo/#/pmac/bulk-upload</example-url>
 */
class BulkUploadComponent {
    constructor(infrastructureService) {
        this.infrastructureService = infrastructureService;
        this.disableUploadButton = true;
        this.placeholder = 'No file chosen';
        this.accept = '';
        this.disabled = false;
        this.url = '/api/infrastructure/bulkOperations';
        this.apiParams = {};
        this.clear = new EventEmitter();
        this.success = new EventEmitter();
        this.error = new EventEmitter();
    }
    onClear() {
        this.disableUploadButton = true;
        this.clear.emit();
    }
    onUploadFileChange(fileList) {
        if (fileList && fileList.length > 0) {
            this.disableUploadButton = false;
        }
    }
    onUpload() {
        this.infrastructureService.upload(this.url, this.bulkUploadFile[0], this.resourceUrl, this.apiParams)
            .subscribe(data => {
            this.bulkUploadFile = null;
            this.success.emit(data);
        }, err => {
            const error = coerceResponseErrors(err);
            this.error.emit(error);
        });
    }
}
BulkUploadComponent.ɵfac = function BulkUploadComponent_Factory(t) { return new (t || BulkUploadComponent)(ɵngcc0.ɵɵdirectiveInject(InfrastructureService)); };
BulkUploadComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BulkUploadComponent, selectors: [["pmac-bulk-upload"]], inputs: { placeholder: "placeholder", accept: "accept", disabled: "disabled", url: "url", apiParams: "apiParams", resourceUrl: "resourceUrl" }, outputs: { clear: "clear", success: "success", error: "error" }, features: [ɵngcc0.ɵɵProvidersFeature([InfrastructureService])], decls: 3, vars: 5, consts: [[3, "disabled", "accept", "placeholder", "ngModel", "ngModelChange", "change", "clear"], ["pmccButton", "", "pmccSize", "md", 1, "pmac-upload-button", 3, "disabled", "click"]], template: function BulkUploadComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "pmcc-file", 0);
        ɵngcc0.ɵɵlistener("ngModelChange", function BulkUploadComponent_Template_pmcc_file_ngModelChange_0_listener($event) { return ctx.bulkUploadFile = $event; })("change", function BulkUploadComponent_Template_pmcc_file_change_0_listener($event) { return ctx.onUploadFileChange($event); })("clear", function BulkUploadComponent_Template_pmcc_file_clear_0_listener() { return ctx.onClear(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(1, "button", 1);
        ɵngcc0.ɵɵlistener("click", function BulkUploadComponent_Template_button_click_1_listener() { return ctx.onUpload(); });
        ɵngcc0.ɵɵtext(2, " Upload\n");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled)("accept", ctx.accept)("placeholder", ctx.placeholder)("ngModel", ctx.bulkUploadFile);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", ctx.disableUploadButton || ctx.disabled);
    } }, directives: [ɵngcc2.FileComponent, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc2.ButtonDirective], styles: [".pmac-upload-button[_ngcontent-%COMP%]{margin-left:5px;display:inline-block;vertical-align:bottom}"] });
BulkUploadComponent.ctorParameters = () => [
    { type: InfrastructureService }
];
BulkUploadComponent.propDecorators = {
    placeholder: [{ type: Input }],
    accept: [{ type: Input }],
    disabled: [{ type: Input }],
    url: [{ type: Input }],
    resourceUrl: [{ type: Input }],
    apiParams: [{ type: Input }],
    clear: [{ type: Output }],
    success: [{ type: Output }],
    error: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BulkUploadComponent, [{
        type: Component,
        args: [{
                selector: 'pmac-bulk-upload',
                template: "<pmcc-file\n  [disabled]=\"disabled\"\n  [accept]=\"accept\"\n  [placeholder]=\"placeholder\"\n  [(ngModel)]=\"bulkUploadFile\"\n  (change)=\"onUploadFileChange($event)\"\n  (clear)=\"onClear()\"\n></pmcc-file>\n<button\n  pmccButton\n  pmccSize=\"md\"\n  class=\"pmac-upload-button\"\n  [disabled]=\"disableUploadButton || disabled\"\n  (click)=\"onUpload()\"\n>\n  Upload\n</button>\n",
                providers: [InfrastructureService],
                styles: [".pmac-upload-button{margin-left:5px;display:inline-block;vertical-align:bottom}"]
            }]
    }], function () { return [{ type: InfrastructureService }]; }, { placeholder: [{
            type: Input
        }], accept: [{
            type: Input
        }], disabled: [{
            type: Input
        }], url: [{
            type: Input
        }], apiParams: [{
            type: Input
        }], clear: [{
            type: Output
        }], success: [{
            type: Output
        }], error: [{
            type: Output
        }], resourceUrl: [{
            type: Input
        }] }); })();

class BulkUploadModule {
}
BulkUploadModule.ɵfac = function BulkUploadModule_Factory(t) { return new (t || BulkUploadModule)(); };
BulkUploadModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: BulkUploadModule });
BulkUploadModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FileModule,
            ButtonModule,
            FormsModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BulkUploadModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    BulkUploadComponent,
                ],
                imports: [
                    CommonModule,
                    FileModule,
                    ButtonModule,
                    FormsModule,
                ],
                exports: [BulkUploadComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BulkUploadModule, { declarations: function () { return [BulkUploadComponent]; }, imports: function () { return [CommonModule,
        FileModule,
        ButtonModule,
        FormsModule]; }, exports: function () { return [BulkUploadComponent]; } }); })();

class PmacModule {
}
PmacModule.ɵfac = function PmacModule_Factory(t) { return new (t || PmacModule)(); };
PmacModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PmacModule });
PmacModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            BulkUploadModule,
            HeaderModule,
            FooterModule,
            SystemNotificationModule,
            BillingStatementModule
        ], SystemNotificationModule, BillingStatementModule, BulkUploadModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PmacModule, [{
        type: NgModule,
        args: [{
                imports: [
                    BulkUploadModule,
                    HeaderModule,
                    FooterModule,
                    SystemNotificationModule,
                    BillingStatementModule
                ],
                exports: [
                    FooterComponent,
                    HeaderComponent,
                    SystemNotificationModule,
                    BillingStatementModule,
                    BulkUploadModule,
                    /* Required for adding component ref*/
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PmacModule, { imports: [BulkUploadModule, HeaderModule, FooterModule, SystemNotificationModule, BillingStatementModule], exports: [FooterComponent, HeaderComponent, SystemNotificationModule, BillingStatementModule, BulkUploadModule] }); })();

/*
 * Public API Surface of pmac
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BillingStatementComponent, BillingStatementModule, BulkUploadComponent, BulkUploadModule, FooterComponent, FooterModule, HeaderComponent, HeaderModule, PmacModule, SystemNotificationComponent, SystemNotificationModule, InfrastructureService as ɵa, AnalyticsService as ɵb, SharedModule as ɵc };

